import React, { useEffect, useState } from 'react';
import advertisingService, { CornerAd } from '../../services/advertisingService';
import { fallbackUploadsSrc, getImageUrl } from '../../utils/imageUrl';
import { isNativeMobileApp } from '../../utils/mobileApp';

const dismissKey = (campaignId: string) => `kcn_mobile_ad_dismissed_${campaignId}`;

const MobileCornerAd: React.FC = () => {
  const [ad, setAd] = useState<CornerAd | null>(null);
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    if (!isNativeMobileApp()) return;

    let cancelled = false;
    void (async () => {
      try {
        const next = await advertisingService.getActiveCornerAd();
        if (cancelled || !next?.image_url) return;
        try {
          if (sessionStorage.getItem(dismissKey(next.campaign_id)) === '1') return;
        } catch {
          // ignore
        }
        setAd(next);
        setHidden(false);
      } catch {
        // no ad
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  if (!isNativeMobileApp() || hidden || !ad) return null;

  const imageSrc = getImageUrl(ad.image_url);

  const dismiss = (event: React.MouseEvent) => {
    event.stopPropagation();
    try {
      sessionStorage.setItem(dismissKey(ad.campaign_id), '1');
    } catch {
      // ignore
    }
    setHidden(true);
  };

  const openAd = () => {
    void advertisingService.recordCornerClick(ad.campaign_id).catch(() => undefined);
    if (ad.link_url) {
      window.open(ad.link_url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="pointer-events-none absolute right-3 z-[60] bottom-[calc(8.75rem+env(safe-area-inset-bottom))]">
      <div className="pointer-events-auto relative">
        <button
          type="button"
          onClick={dismiss}
          className="absolute -right-1.5 -top-1.5 z-10 flex h-5 w-5 items-center justify-center rounded-full bg-black/80 text-[10px] text-white"
          aria-label="Đóng quảng cáo"
        >
          ×
        </button>
        <button
          type="button"
          onClick={openAd}
          className="h-20 w-20 overflow-hidden rounded-2xl border border-white/80 bg-white shadow-lg"
          aria-label={ad.title || 'Quảng cáo'}
        >
          {imageSrc ? (
            <img
              src={imageSrc}
              alt={ad.title}
              className="h-full w-full object-cover"
              onError={(event) => {
                const fallback = fallbackUploadsSrc(event.currentTarget.src, ad.image_url);
                if (fallback) event.currentTarget.src = fallback;
              }}
            />
          ) : (
            <span className="flex h-full w-full items-center justify-center text-[10px] text-black/40">Ad</span>
          )}
        </button>
      </div>
    </div>
  );
};

export default MobileCornerAd;
